import { useQuery } from "react-query";
import { ReferentialApi } from "../../api";
import { useApiService } from "../useApiService";

export function useGradeSubStatusRef() {
  const api = useApiService(ReferentialApi);
  const { data, isFetching, refetch } = useQuery(
    "ref-grade-sub-statuses",
    async () => {
      return await api.gradeSubStatuses();
    },
    { staleTime: Infinity }
  );

  return {
    subStatuses: data ?? [],
    subStatusesLoading: isFetching,
    refetchSubStatusesRef: refetch,
  };
}
